// import React, { useState, useEffect, useRef } from "react";
// import Topnav from "./Navbar/Topnav";
// import Bnblogo from "../../assets/NavLogo/BNBLOGO.png";
// import {
//   FiSearch,
//   FiUser,
//   FiMenu,
//   FiX,
//   FiChevronRight,
//   FiLogOut,
// } from "react-icons/fi";
// import { FaPinterestP, FaShoppingCart, FaStore } from "react-icons/fa";
// import BottomNav from "./Navbar/BottomNav";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../../utils/AuthContext ";
// import {
//   FaFacebook,
//   FaInstagram,
//   FaYoutube,
//   FaGooglePlay,
// } from "react-icons/fa";
// import { Link } from "react-router-dom";
// import { RiTwitterXFill } from "react-icons/ri";
// import axios from "axios";

// const Navbar = () => {
//   const [searchQuery, setSearchQuery] = useState("");
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [cartItemCount, setCartItemCount] = useState(0);
//   const { user, logout } = useAuth();
//   const navigate = useNavigate();
//   const sidebarRef = useRef(null);

//   const fetchCartCount = async () => {
//     if (!user?._id) {
//       setCartItemCount(0);
//       return;
//     }

//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_URL}/cart/get-users-cart/${user._id}`
//       );
//       const cartItems =
//         response?.data?.items?.filter((item) => item.product !== null) || [];

//       // Count the number of unique products in cart (not quantity)
//       const totalCount = cartItems.length;
//       setCartItemCount(totalCount);
//     } catch (error) {
//       console.error("Error fetching cart count:", error);
//       setCartItemCount(0);
//     }
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 768);
//     };

//     handleResize();
//     window.addEventListener("resize", handleResize);

//     const handleClickOutside = (event) => {
//       if (
//         sidebarRef.current &&
//         !sidebarRef.current.contains(event.target) &&
//         !event.target.closest("[data-menu-toggle]")
//       ) {
//         setSidebarOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   useEffect(() => {
//     if (sidebarOpen) {
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "auto";
//     }

//     return () => {
//       document.body.style.overflow = "auto";
//     };
//   }, [sidebarOpen]);

//   // Fetch cart count when user changes or component mounts
//   useEffect(() => {
//     fetchCartCount();
//   }, [user]);

//   // Optional: Set up periodic refresh of cart count
//   useEffect(() => {
//     if (user) {
//       const interval = setInterval(fetchCartCount, 30000); // Refresh every 30 seconds
//       return () => clearInterval(interval);
//     }
//   }, [user]);

//   const handleLogout = () => {
//     logout();
//     navigate("/sign-in");
//     setSidebarOpen(false);
//     setCartItemCount(0); // Reset cart count on logout
//   };

//   const handleSearch = (e) => {
//     e.preventDefault();
//     if (searchQuery.trim()) {
//       navigate(`/products?search=${encodeURIComponent(searchQuery.trim())}`);
//     }
//   };

//   const handleMobileSearch = (e) => {
//     e.preventDefault();
//     if (searchQuery.trim()) {
//       navigate(`/products?search=${encodeURIComponent(searchQuery.trim())}`);
//     }
//   };

//   const toggleSidebar = () => {
//     setSidebarOpen(!sidebarOpen);
//   };

//   const handleProtectedNavigation = (route) => {
//     if (user) {
//       navigate(route);
//       if (route === "/all-cart-product") {
//         setTimeout(fetchCartCount, 500); // Small delay to allow for any cart updates
//       }
//     } else {
//       navigate("/sign-in");
//     }

//     setSidebarOpen(false);
//   };

//   return (
//     <React.Fragment>
//       <Topnav />
//       <nav className="bg-white shadow-md relative z-10">
//         <div className="w-full mx-auto px-3 sm:px-6 lg:px-8">
//           <div className="flex justify-between items-center py-3 gap-4">
//             {/* Logo */}
//             <div className="flex-shrink-0">
//               <img
//                 src={Bnblogo}
//                 alt="BNB Logo"
//                 className="sm:h-16 w-auto h-10"
//                 onClick={() => navigate("/")}
//                 style={{ cursor: "pointer" }}
//               />
//             </div>

//             {/* Search & Welcome (Center) */}
//             <div className="hidden lg:flex items-center justify-evenly flex-grow">
//               <form
//                 onSubmit={handleSearch}
//                 className="flex rounded-md overflow-hidden border border-gray-400 w-full max-w-xl"
//               >
//                 <div className="flex items-center px-3 text-gray-500">
//                   <FiSearch className="w-6 h-6" />
//                 </div>
//                 <input
//                   type="text"
//                   className="flex-1 px-2 py-2.5 text-md text-gray-800 placeholder-gray-500 outline-none"
//                   placeholder="Search"
//                   value={searchQuery}
//                   onChange={(e) => setSearchQuery(e.target.value)}
//                 />
//                 <button
//                   type="submit"
//                   className="bg-green-500 hover:bg-green-600 text-white px-6 py-2 text-md font-medium"
//                 >
//                   Search
//                 </button>
//               </form>

//               {user && (
//                 <div className="flex items-center bg-gradient-to-r from-orange-50 to-orange-100 px-4 py-2 rounded-lg border border-orange-200 shadow-sm lg:flex-col xl:flex-row">
//                   <p className="text-md text-orange-600 font-medium mr-1">
//                     Welcome,
//                   </p>
//                   <p className="text-md font-semibold text-gray-800 capitalize">
//                     {user.firstName}
//                   </p>
//                 </div>
//               )}
//             </div>

//             {/* Right Side Icons */}
//             <div className="flex items-center space-x-5">
//               {/* User Account Icon */}
//               <div
//                 className="text-orange-700 hover:text-orange-500 cursor-pointer transition-colors"
//                 onClick={() => handleProtectedNavigation("/display-house")}
//               >
//                 <FaStore size={24} />
//               </div>

//               {/* Shopping Cart Icon with Count Badge */}
//               <div
//                 className="relative text-orange-700 hover:text-orange-500 cursor-pointer transition-colors"
//                 onClick={() => handleProtectedNavigation("/all-cart-product")}
//               >
//                 <FaShoppingCart size={24} />
//                 {cartItemCount > 0 && (
//                   <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center min-w-5">
//                     {cartItemCount > 99 ? "99+" : cartItemCount}
//                   </span>
//                 )}
//               </div>

//               {/* Menu Icon (Mobile & Desktop) */}
//               <div
//                 className="text-orange-700 hover:text-orange-500 cursor-pointer transition-colors"
//                 onClick={toggleSidebar}
//                 data-menu-toggle
//               >
//                 <FiMenu size={24} />
//               </div>
//             </div>
//           </div>
//         </div>
//       </nav>

//       {/* Sidebar Menu (Mobile & Desktop) */}
//       <div
//         className={`fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity duration-300 ${
//           sidebarOpen ? "opacity-100" : "opacity-0 pointer-events-none"
//         }`}
//       >
//         <div
//           ref={sidebarRef}
//           className={`fixed top-0 left-0 h-full w-80 bg-white shadow-lg transform transition-transform duration-300 ease-in-out overflow-y-auto ${
//             sidebarOpen ? "translate-x-0" : "-translate-x-full"
//           }`}
//         >
//           {/* Sidebar Header */}
//           <div className="flex justify-between items-center p-4 border-b border-gray-200">
//             <div className="flex flex-col">
//               <div className="flex items-center space-x-2">
//                 <div
//                   className="p-2 bg-orange-300 rounded-full flex items-center justify-center cursor-pointer"
//                   onClick={() => {
//                     handleProtectedNavigation("/profile");
//                     // setSidebarOpen(false);
//                   }}
//                 >
//                   {user?.imageUrl ? (
//                     <img
//                       src={user.imageUrl}
//                       alt="User Avatar"
//                       className="h-8 w-8 rounded-full object-cover"
//                     />
//                   ) : user?.gender === "male" ? (
//                     <img
//                       src="https://static.vecteezy.com/system/resources/thumbnails/004/607/791/small_2x/man-face-emotive-icon-smiling-male-character-in-blue-shirt-flat-illustration-isolated-on-white-happy-human-psychological-portrait-positive-emotions-user-avatar-for-app-web-design-vector.jpg"
//                       alt="Default Male Avatar"
//                       className="h-8 w-8 rounded-full object-cover"
//                     />
//                   ) : user?.gender === "female" ? (
//                     <img
//                       src="https://cdn-icons-png.flaticon.com/512/6997/6997662.png"
//                       alt="Default Female Avatar"
//                       className="h-8 w-8 rounded-full object-cover"
//                     />
//                   ) : (
//                     <FiUser className="text-white h-8 w-8" />
//                   )}
//                 </div>

//                 <div className="text-md text-gray-900 capitalize">
//                   {user ? (
//                     <span className="font-medium">
//                       {user.firstName} {user.lastName}
//                     </span>
//                   ) : (
//                     <div className="flex space-x-2">
//                       <span
//                         className="text-orange-500 font-medium cursor-pointer"
//                         onClick={() => {
//                           navigate("/sign-in");
//                           setSidebarOpen(false);
//                         }}
//                       >
//                         Sign in
//                       </span>
//                       <span>|</span>
//                       <span
//                         className="text-orange-500 font-medium cursor-pointer"
//                         onClick={() => {
//                           navigate("/register");
//                           setSidebarOpen(false);
//                         }}
//                       >
//                         Register
//                       </span>
//                     </div>
//                   )}
//                 </div>
//               </div>
//               {!user && (
//                 <div className="text-xs text-gray-500 mt-1">
//                   Sign in to get more opportunities
//                 </div>
//               )}
//             </div>
//             <button
//               className="p-1 rounded-full hover:bg-gray-100"
//               onClick={toggleSidebar}
//             >
//               <FiX size={20} className="text-gray-500" />
//             </button>
//           </div>

//           {/* Sidebar Menu Items */}
//           <div className="py-2">
//             <div
//               className="px-4 py-3 text-sm font-light border-b border-gray-100 flex justify-between items-center cursor-pointer hover:text-orange-600"
//               onClick={() => {
//                 navigate("/buying-guide");
//                 setSidebarOpen(false);
//               }}
//             >
//               <span>BUYING GUIDE</span>
//               <FiChevronRight size={18} className="" />
//             </div>

//             <div
//               className="px-4 py-3 text-sm font-light border-b border-gray-100 flex justify-between items-center cursor-pointer hover:text-orange-600"
//               onClick={() => handleProtectedNavigation("/comparision")}
//             >
//               <span>COMPARE</span>
//               <FiChevronRight size={18} className="" />
//             </div>

//             <div
//               className="px-4 py-3 text-sm font-light border-b border-gray-100 flex justify-between items-center cursor-pointer hover:text-orange-600"
//               onClick={() => handleProtectedNavigation("/wishlist")}
//             >
//               <span>WISH LIST</span>
//               <FiChevronRight size={18} className="" />
//             </div>

//             <div
//               className="px-4 py-3 text-sm font-light border-b border-gray-100 flex justify-between items-center cursor-pointer hover:text-orange-600"
//               onClick={() => handleProtectedNavigation("/orders")}
//             >
//               <span>ORDERS</span>
//               <FiChevronRight size={18} className="" />
//             </div>

//             <div
//               className="px-4 py-3 text-sm font-light border-b border-gray-100 flex justify-between items-center cursor-pointer hover:text-orange-600"
//               onClick={() => {
//                 navigate("/contact");
//                 setSidebarOpen(false);
//               }}
//             >
//               <span>CONTACT</span>
//               <FiChevronRight size={18} className="" />
//             </div>

//             <div
//               className="px-4 py-3 text-sm font-light border-b border-gray-100 flex justify-between items-center cursor-pointer hover:text-orange-600"
//               onClick={() => handleProtectedNavigation("/addresses")}
//             >
//               <span>SAVED ADDRESSES</span>
//               <FiChevronRight size={18} className="" />
//             </div>

//             <div
//               className="px-4 py-3 text-sm font-light border-b border-gray-100 cursor-pointer hover:text-orange-600"
//               onClick={() => {
//                 navigate("/products");
//                 setSidebarOpen(false);
//               }}
//             >
//               <span>BULK ORDER</span>
//             </div>

//             <div
//               className="px-4 py-3 text-sm font-light border-b border-gray-100 cursor-pointer hover:text-orange-600"
//               onClick={() => {
//                 navigate("/display-house");
//                 setSidebarOpen(false);
//               }}
//             >
//               <span>DISPLAY HOUSE</span>
//             </div>

//             {user && (
//               <div
//                 className="px-4 py-3 flex items-center gap-2 text-red-600 font-semibold text-md cursor-pointer hover:bg-red-50 transition-colors rounded-md"
//                 onClick={handleLogout}
//               >
//                 <FiLogOut size={18} />
//                 <span>Logout</span>
//               </div>
//             )}
//           </div>

//           {/* Social Media Section */}
//           <div className="px-4 pb-4 pt-2">
//             <h3 className="font-medium text-md mb-2">Get Social</h3>
//             <p className="text-gray-600 text-sm font-light mb-4">
//               Join our group and be the first to learn about all promotions and
//               offers!
//             </p>

//             {/* Social Media Icons */}
//             <div className="flex items-center space-x-4 mb-4">
//               <a
//                 href="https://www.facebook.com/Bricknbar/"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center hover:bg-orange-80 transition hover:bg-orange-100"
//               >
//                 <FaFacebook
//                   size={18}
//                   className="text-orange-600 hover:text-red-600"
//                 />
//               </a>
//               <a
//                 href="https://www.instagram.com/bricknbar/"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center hover:bg-orange-80 transition hover:bg-orange-100"
//               >
//                 <FaInstagram
//                   size={18}
//                   className="text-orange-600 hover:text-red-600"
//                 />
//               </a>
//               <a
//                 href="https://www.youtube.com/@BricknBar"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center hover:bg-orange-100 transition"
//               >
//                 <FaYoutube
//                   size={18}
//                   className="text-orange-600 hover:text-red-600"
//                 />
//               </a>
//               <a
//                 href="https://x.com/BricknBar"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center hover:bg-orange-100 transition"
//               >
//                 <RiTwitterXFill
//                   size={18}
//                   className="text-orange-600 hover:text-red-600"
//                 />
//               </a>
//               <a
//                 href="https://in.pinterest.com/brickandbar/_pins/"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center hover:bg-orange-100 transition"
//               >
//                 <FaPinterestP
//                   size={18}
//                   className="text-orange-600 hover:text-red-600"
//                 />
//               </a>
//             </div>

//             {/* Google Play Download Button */}
//             <Link
//               to="#"
//               className="flex items-center px-4 py-2 bg-white rounded-xl shadow-md hover:shadow-lg transition border mb-14 sm:mb-0"
//             >
//               <FaGooglePlay className="text-2xl mr-3" />
//               <div className="text-left leading-tight">
//                 <p className="text-xs">Download on the</p>
//                 <p className="text-sm font-semibold">Google play</p>
//               </div>
//             </Link>
//           </div>
//         </div>
//       </div>

//       {/* Mobile search bar at bottom */}
//       <div className="lg:hidden px-3 py-2 bg-white shadow-md">
//         <div className="space-y-3">
//           {/* Mobile Welcome Message */}
//           {user && (
//             <div className="flex items-center justify-center">
//               <div className="flex items-center bg-gradient-to-r from-orange-50 to-orange-100 px-4 py-2 rounded-lg border border-orange-200 shadow-sm w-full justify-center">
//                 <div className="flex items-center space-x-2">
//                   <div>
//                     <span className="text-sm text-orange-600 font-medium">
//                       Welcome,
//                     </span>
//                     <span className="text-sm font-semibold text-gray-800 capitalize">
//                       {user.firstName}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Search Form */}
//           <form
//             onSubmit={handleMobileSearch}
//             className="flex justify-center items-center w-full"
//           >
//             <div className="relative w-full max-w-xl">
//               <div className="flex shadow-lg rounded-xl overflow-hidden border border-gray-300 focus-within:ring-2 focus-within:ring-orange-500 transition-all duration-200">
//                 <input
//                   type="text"
//                   className="flex-1 px-4 py-2 text-sm text-gray-800 placeholder-gray-400 outline-none"
//                   placeholder="Search anything..."
//                   value={searchQuery}
//                   onChange={(e) => setSearchQuery(e.target.value)}
//                 />
//                 <button
//                   type="submit"
//                   className="text-gray-400 px-4 flex items-center justify-center hover:text-orange-500 transition-colors"
//                   title="Search"
//                 >
//                   <FiSearch className="w-5 h-5" />
//                 </button>
//               </div>
//             </div>
//           </form>
//         </div>
//       </div>

//       <BottomNav />
//     </React.Fragment>
//   );
// };

// export default Navbar;

import React, { useState, useEffect, useRef } from "react";
import Topnav from "./Navbar/Topnav";
import Bnblogo from "../../assets/NavLogo/BNBLOGO.png";
import {
  FiSearch,
  FiUser,
  FiMenu,
  FiX,
  FiChevronRight,
  FiLogOut,
  FiPhone,
} from "react-icons/fi";
import { FaPinterestP, FaShoppingCart, FaStore } from "react-icons/fa";
import BottomNav from "./Navbar/BottomNav";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../utils/AuthContext ";
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaGooglePlay,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { RiTwitterXFill } from "react-icons/ri";
import axios from "axios";

const Navbar = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [cartItemCount, setCartItemCount] = useState(0);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const sidebarRef = useRef(null);

  const fetchCartCount = async () => {
    if (!user?._id) {
      setCartItemCount(0);
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/cart/get-users-cart/${user._id}`
      );
      const cartItems =
        response?.data?.items?.filter((item) => item.product !== null) || [];

      // Count the number of unique products in cart (not quantity)
      const totalCount = cartItems.length;
      setCartItemCount(totalCount);
    } catch (error) {
      console.error("Error fetching cart count:", error);
      setCartItemCount(0);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        !event.target.closest("[data-menu-toggle]")
      ) {
        setSidebarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (sidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [sidebarOpen]);

  // Fetch cart count when user changes or component mounts
  useEffect(() => {
    fetchCartCount();
  }, [user]);

  // Optional: Set up periodic refresh of cart count
  useEffect(() => {
    if (user) {
      const interval = setInterval(fetchCartCount, 30000); // Refresh every 30 seconds
      return () => clearInterval(interval);
    }
  }, [user]);

  const handleLogout = () => {
    logout();
    navigate("/sign-in");
    setSidebarOpen(false);
    setCartItemCount(0); // Reset cart count on logout
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/products?search=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  const handleMobileSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/products?search=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleProtectedNavigation = (route) => {
    if (user) {
      navigate(route);
      if (route === "/all-cart-product") {
        setTimeout(fetchCartCount, 500); // Small delay to allow for any cart updates
      }
    } else {
      navigate("/sign-in");
    }

    setSidebarOpen(false);
  };

  return (
    <React.Fragment>
      <Topnav />
      <nav className="bg-white shadow-md relative z-10">
        <div className="w-full mx-auto px-3 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-2 gap-4">
            {/* Logo */}
            <div className="flex-shrink-0">
              <img
                src={Bnblogo}
                alt="BNB Logo"
                className="sm:h-16 w-auto h-10"
                onClick={() => navigate("/")}
                style={{ cursor: "pointer" }}
              />
            </div>

            {/* Search & Phone Number (Center) */}
            <div className="hidden lg:flex items-center justify-evenly flex-grow">
              <form
                onSubmit={handleSearch}
                className="flex rounded-md overflow-hidden border border-gray-400 w-full max-w-xl"
              >
                <div className="flex items-center px-3 text-gray-500">
                  <FiSearch className="w-6 h-6" />
                </div>
                <input
                  type="text"
                  className="flex-1 px-2 py-2.5 text-md text-gray-800 placeholder-gray-500 outline-none"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <button
                  type="submit"
                  className="bg-[#00A2A2] hover:bg-teal-600 text-white px-6 py-2 text-md font-medium"
                >
                  Search
                </button>
              </form>

              {/* Phone Number Display */}
              <div className="items-center bg-gradient-to-r from-teal-50 to-teal-100 px-4 py-2 rounded-lg border border-teal-200 shadow-sm hidden xl:flex">
                <FiPhone className="text-teal-600 mr-2" size={18} />
                <span className="text-md font-semibold text-gray-800">
                  +91 (9777) 772-782
                </span>
              </div>
            </div>

            {/* Right Side Icons */}
            <div className="flex items-center space-x-5">
              {/* User Account Icon */}
              <div
                className="text-orange-700 hover:text-orange-500 cursor-pointer transition-colors"
                onClick={() => handleProtectedNavigation("/display-house")}
              >
                <FaStore size={24} />
              </div>

              {/* Shopping Cart Icon with Count Badge */}
              <div
                className="relative text-orange-700 hover:text-orange-500 cursor-pointer transition-colors"
                onClick={() => handleProtectedNavigation("/all-cart-product")}
              >
                <FaShoppingCart size={24} />
                {cartItemCount > 0 && (
                  <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center min-w-5">
                    {cartItemCount > 99 ? "99+" : cartItemCount}
                  </span>
                )}
              </div>

              {/* Menu Icon (Mobile & Desktop) */}
              <div
                className="text-orange-700 hover:text-orange-500 cursor-pointer transition-colors"
                onClick={toggleSidebar}
                data-menu-toggle
              >
                <FiMenu size={24} />
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Sidebar Menu (Mobile & Desktop) */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity duration-300 ${
          sidebarOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      >
        <div
          ref={sidebarRef}
          className={`fixed top-0 left-0 h-full w-80 bg-white shadow-lg transform transition-transform duration-300 ease-in-out overflow-y-auto ${
            sidebarOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          {/* Sidebar Header */}
          <div className="flex justify-between items-center p-4 border-b border-gray-200">
            <div className="flex flex-col">
              <div className="flex items-center space-x-2">
                <div
                  className="p-2 bg-orange-300 rounded-full flex items-center justify-center cursor-pointer"
                  onClick={() => {
                    handleProtectedNavigation("/profile");
                    // setSidebarOpen(false);
                  }}
                >
                  {user?.imageUrl ? (
                    <img
                      src={user.imageUrl}
                      alt="User Avatar"
                      className="h-8 w-8 rounded-full object-cover"
                    />
                  ) : user?.gender === "male" ? (
                    <img
                      src="https://static.vecteezy.com/system/resources/thumbnails/004/607/791/small_2x/man-face-emotive-icon-smiling-male-character-in-blue-shirt-flat-illustration-isolated-on-white-happy-human-psychological-portrait-positive-emotions-user-avatar-for-app-web-design-vector.jpg"
                      alt="Default Male Avatar"
                      className="h-8 w-8 rounded-full object-cover"
                    />
                  ) : user?.gender === "female" ? (
                    <img
                      src="https://cdn-icons-png.flaticon.com/512/6997/6997662.png"
                      alt="Default Female Avatar"
                      className="h-8 w-8 rounded-full object-cover"
                    />
                  ) : (
                    <FiUser className="text-white h-8 w-8" />
                  )}
                </div>

                <div className="text-md text-gray-900 capitalize">
                  {user ? (
                    <span className="font-medium">
                      {user.firstName} {user.lastName}
                    </span>
                  ) : (
                    <div className="flex space-x-2">
                      <span
                        className="text-orange-500 font-medium cursor-pointer"
                        onClick={() => {
                          navigate("/sign-in");
                          setSidebarOpen(false);
                        }}
                      >
                        Sign in
                      </span>
                      <span>|</span>
                      <span
                        className="text-orange-500 font-medium cursor-pointer"
                        onClick={() => {
                          navigate("/register");
                          setSidebarOpen(false);
                        }}
                      >
                        Register
                      </span>
                    </div>
                  )}
                </div>
              </div>
              {!user && (
                <div className="text-xs text-gray-500 mt-1">
                  Sign in to get more opportunities
                </div>
              )}
            </div>
            <button
              className="p-1 rounded-full hover:bg-gray-100"
              onClick={toggleSidebar}
            >
              <FiX size={20} className="text-gray-500" />
            </button>
          </div>

          {/* Sidebar Menu Items */}
          <div className="py-2">
            <div
              className="px-4 py-3 text-sm font-light border-b border-gray-100 flex justify-between items-center cursor-pointer hover:text-orange-600"
              onClick={() => {
                navigate("/buying-guide");
                setSidebarOpen(false);
              }}
            >
              <span>BUYING GUIDE</span>
              <FiChevronRight size={18} className="" />
            </div>

            <div
              className="px-4 py-3 text-sm font-light border-b border-gray-100 flex justify-between items-center cursor-pointer hover:text-orange-600"
              onClick={() => handleProtectedNavigation("/comparision")}
            >
              <span>COMPARE</span>
              <FiChevronRight size={18} className="" />
            </div>

            <div
              className="px-4 py-3 text-sm font-light border-b border-gray-100 flex justify-between items-center cursor-pointer hover:text-orange-600"
              onClick={() => handleProtectedNavigation("/wishlist")}
            >
              <span>WISH LIST</span>
              <FiChevronRight size={18} className="" />
            </div>

            <div
              className="px-4 py-3 text-sm font-light border-b border-gray-100 flex justify-between items-center cursor-pointer hover:text-orange-600"
              onClick={() => handleProtectedNavigation("/orders")}
            >
              <span>ORDERS</span>
              <FiChevronRight size={18} className="" />
            </div>

            <div
              className="px-4 py-3 text-sm font-light border-b border-gray-100 flex justify-between items-center cursor-pointer hover:text-orange-600"
              onClick={() => {
                navigate("/contact");
                setSidebarOpen(false);
              }}
            >
              <span>CONTACT</span>
              <FiChevronRight size={18} className="" />
            </div>

            <div
              className="px-4 py-3 text-sm font-light border-b border-gray-100 flex justify-between items-center cursor-pointer hover:text-orange-600"
              onClick={() => handleProtectedNavigation("/addresses")}
            >
              <span>SAVED ADDRESSES</span>
              <FiChevronRight size={18} className="" />
            </div>

            <div
              className="px-4 py-3 text-sm font-light border-b border-gray-100 cursor-pointer hover:text-orange-600"
              onClick={() => {
                navigate("/products");
                setSidebarOpen(false);
              }}
            >
              <span>BULK ORDER</span>
            </div>

            <div
              className="px-4 py-3 text-sm font-light border-b border-gray-100 cursor-pointer hover:text-orange-600"
              onClick={() => {
                navigate("/display-house");
                setSidebarOpen(false);
              }}
            >
              <span>DISPLAY HOUSE</span>
            </div>

            {user && (
              <div
                className="px-4 py-3 flex items-center gap-2 text-red-600 font-semibold text-md cursor-pointer hover:bg-red-50 transition-colors rounded-md"
                onClick={handleLogout}
              >
                <FiLogOut size={18} />
                <span>Logout</span>
              </div>
            )}
          </div>

          {/* Social Media Section */}
          <div className="px-4 pb-4 pt-2">
            <h3 className="font-medium text-md mb-2">Get Social</h3>
            <p className="text-gray-600 text-sm font-light mb-4">
              Join our group and be the first to learn about all promotions and
              offers!
            </p>

            {/* Social Media Icons */}
            <div className="flex items-center space-x-4 mb-4">
              <a
                href="https://www.facebook.com/Bricknbar/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center hover:bg-orange-80 transition hover:bg-orange-100"
              >
                <FaFacebook
                  size={18}
                  className="text-orange-600 hover:text-red-600"
                />
              </a>
              <a
                href="https://www.instagram.com/bricknbar/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center hover:bg-orange-80 transition hover:bg-orange-100"
              >
                <FaInstagram
                  size={18}
                  className="text-orange-600 hover:text-red-600"
                />
              </a>
              <a
                href="https://www.youtube.com/@BricknBar"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center hover:bg-orange-100 transition"
              >
                <FaYoutube
                  size={18}
                  className="text-orange-600 hover:text-red-600"
                />
              </a>
              <a
                href="https://x.com/BricknBar"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center hover:bg-orange-100 transition"
              >
                <RiTwitterXFill
                  size={18}
                  className="text-orange-600 hover:text-red-600"
                />
              </a>
              <a
                href="https://in.pinterest.com/brickandbar/_pins/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center hover:bg-orange-100 transition"
              >
                <FaPinterestP
                  size={18}
                  className="text-orange-600 hover:text-red-600"
                />
              </a>
            </div>

            {/* Google Play Download Button */}
            <Link
              to="#"
              className="flex items-center px-4 py-2 bg-white rounded-xl shadow-md hover:shadow-lg transition border mb-14 sm:mb-0"
            >
              <FaGooglePlay className="text-2xl mr-3" />
              <div className="text-left leading-tight">
                <p className="text-xs">Download on the</p>
                <p className="text-sm font-semibold">Google play</p>
              </div>
            </Link>
          </div>
        </div>
      </div>

      {/* Mobile search bar at bottom */}
      <div className="lg:hidden px-3 py-2 bg-white shadow-md">
        <div className="space-y-3">
          {/* Search Form */}
          <form
            onSubmit={handleMobileSearch}
            className="flex justify-center items-center w-full"
          >
            <div className="relative w-full max-w-xl">
              <div className="flex shadow-lg rounded-xl overflow-hidden border border-gray-300 focus-within:ring-2 focus-within:ring-orange-500 transition-all duration-200">
                <input
                  type="text"
                  className="flex-1 px-4 py-2 text-sm text-gray-800 placeholder-gray-400 outline-none"
                  placeholder="Search anything..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <button
                  type="submit"
                  className="text-gray-400 px-4 flex items-center justify-center hover:text-orange-500 transition-colors"
                  title="Search"
                >
                  <FiSearch className="w-5 h-5" />
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <BottomNav />
    </React.Fragment>
  );
};

export default Navbar;
